var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPumlx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFC",
    d: "M10.723 10.715H8.485c-.878 0-1.924.227-2.082 1.208c-.185 1.097.75 1.363 1.667 1.363h3.325c1.085 0 1.929-1.213 2.083-2.13l.065-.442h-.84l-.052.3c-.094.592-.57 1.406-1.26 1.415H8.143c-.356 0-.935-.026-.858-.506c.06-.351.768-.351 1.2-.351h1.586c.137-.287.403-.592.652-.857m.214-.21c.266-.232.587-.43.968-.545l.472-2.246h.814s-.171 1.106-.343 2.143h.836l.459-3h-2.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFC",
    d: "m14.297 11.293l.098-.578h.875c-.056.257-.103.5-.155.715C14.828 13.2 13.307 15 11.4 15H8.074c-.87 0-1.791-.188-2.477-.784c-.759-.664-.986-1.611-.832-2.571C5.065 9.84 6.78 9 8.49 9h1.075l.832-3.857h5.888s-.437 2.593-.848 4.714h-.892C14.854 8.087 15.24 6 15.24 6h-4.18l-.831 3.857H8.485c-1.414 0-2.837.66-2.935 2.199a2.5 2.5 0 0 0 .004.369c.043.445.244.86.583 1.157c.523.458 1.251.561 1.928.561h3.33c1.5 0 2.675-1.483 2.902-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32D7AF",
    d: "m12.827 14.67l-.934.33l-.275 1.286h-.814l.21-1.286h-.832l-.325 2.143h2.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32D7AF",
    d: "M9.304 15c-.27 1.522-.544 3-.544 3h4.178l.832-3.857h1.744c1.414 0 2.837-.66 2.936-2.199a2 2 0 0 0-.005-.368a1.75 1.75 0 0 0-.582-1.157c-.523-.459-1.252-.562-1.93-.562H12.6c-1.402 0-2.516 1.286-2.842 2.572h-.857C9.252 10.706 10.74 9 12.6 9h3.325c.87 0 1.792.189 2.477.784c.76.665.986 1.612.832 2.572C18.934 14.16 17.22 15 15.51 15h-1.067l-.832 3.857H7.714s.33-1.954.686-3.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32D7AF",
    d: "M10.628 12.429c.3-.832 1.05-1.715 1.976-1.715h3.326c.917 0 1.851.266 1.671 1.363c-.163.982-1.209 1.209-2.087 1.209h-1.157l.471-.857h.686c.433 0 1.14 0 1.2-.352c.077-.48-.502-.505-.857-.505h-3.253c-.484.004-.866.411-1.08.857z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumlx);
export default __webpack_public_path__ + "static/media/pumlx.cfdf4b4a65f95b44f4427836566cd77c.svg";
export { ForwardRef as ReactComponent };